// @flow
import React from 'react';
import Flex from '@waglabs/flex';

type BodyContainerProps = {
  children: any,
  alignItems?: string,
  flexDirection?: string,
};

export const BodyContainer = ({
  children,
  ...rest
}: BodyContainerProps) => (
  <Flex
    boxSizing="border-box"
    width={1}
    height="100%"
    m="0 auto"
    {...rest}
  >
    {children}
  </Flex>
);

BodyContainer.defaultProps = {
  alignItems: 'center',
  flexDirection: 'column',
  maxWidth: ['100%', 688, 1120, 1600],
};
